class DataListNotificationsController {

    constructor() {

        this._dataListTemplate = null;
        this._notificationsListTemplate = null;
        this._dataListData = new DataListData();
        this._listNotificationsData = new ListNotificationsData();
        this._notificationTypes = new NotificationTypes();
        this._dataListUtils = new DataListUtils();
        this.openInDrawer = false;

        this._loadTemplates();
        this._loadPartials();

    }

    _loadTemplates() {

        this._dataListTemplate = Handlebars.compile($("#dataListScreen").html());
        this._notificationsListTemplate = Handlebars.compile($("#notificationsListFragment").html());

    }

    _loadPartials() {
        Handlebars.registerPartial("activityCard", $("#activityCard").html());
    }

    _enableHandlers() {
        if(!this.openInDrawer) {
            $("section.data-list-section div.back-button").on(
                "click.closeScreen",
                this._dataListUtils.closeScreen.bind(this)
            );
        }
        
        $("section.data-list-section div.search-button").on("click.openSearchInput", this._dataListUtils.onToggleSeachButton.bind(this));
        $("section.data-list-section form.search-form").on("submit.search", this._onSearchSubmit.bind(this));
        $("section.data-list-section input.search-input").on("input.change", this._dataListUtils.onInputChange.bind(this));
        $("section.data-list-section div.clear-search-button").on("click.clearSearch", this._dataListUtils.onClearSearch.bind(this));
        $("section.data-list-section div.section-content").on("click.notificationUserProfile", "span.open-profile-button", this._onclickUser.bind(this));
        $("section.data-list-section #open-mark-as-seen-modal").on("click.openMarkAsSeenModal", this._onOpenMarkAllNotificationsAsReadModal.bind(this));
        $("section.data-list-section #toggle-unread-button").on("click.toggleUnreadOnly", this._onToggleUnreadOnly.bind(this));
    }

    _onOpenMarkAllNotificationsAsReadModal() {
        document.dispatchEvent(new CustomEvent('openMarkAllNotificationsAsReadModal'));
    }

    _onToggleUnreadOnly() {
        const button =  $("section.data-list-section #toggle-unread-button");
        const isSecondary = button.hasClass('button-secondary');

        if (isSecondary) {
            button.attr('class', 'btn button-outline btn-md world_color_1_bc world_color_1');
        } else {
            button.attr('class', 'btn button-secondary btn-md');
        }
        
        this._listNotificationsData.toggleShowOnlyUnread(!isSecondary);
        this._updateNotificationListHtml();
    }

    _updateNotificationListHtml() {
        const $sectionContent = $("section.data-list-section div.section-content");
        $sectionContent.html(this._notificationsListTemplate({
            world: world,
            notifications: this._listNotificationsData.getNotificationsList(),
            notificationsTypes: this._notificationTypes.getNotificationTypes()
        }));

        $('div.activity-card.is-notification-card .mark-as-seen-button').hover(function(element) {
            element.currentTarget.classList.add('world_color_1_sc');
        }, function(element) {
            element.currentTarget.classList.remove('world_color_1_sc');
        });
    }

    _drawScreen(context) {

        if(this.openInDrawer) {
            $("#notification-drawer").append(this._dataListTemplate(context));
        } else {
            baseController.stackSimpleContent(this._dataListTemplate, context);
        }

        const $sectionContent = $("section.data-list-section div.section-content");

        _.forEach(context.notifications, function(notification) {

            if (notification.value.alert_original) {
                notification.value.alertFormatted = DocumentationUtils.formatNotificationCommentMentions(notification.value.alert_original, notification.value.mentions, null);
            }

            if (notification.value.internal_link) {
                const documentation = documentationScreenController.getDocument(notification.value.internal_link.resource);
                if (documentation !== null) {
                    notification.value.internal_link.documentData = documentation;
                    notification.value.internal_link.documentData.progressState = documentationScreenController.documentationProgress.getProgressState(notification.value.internal_link.documentData);
                    DocumentationUtils.formatDocumentParameters(notification.value.internal_link.documentData);
                } else {
                    api.setNotificationReaded(notification.id, undefined, false);
                }
            }
        });

        this._listNotificationsData.setNotificationsList(context.notifications);
        this._listNotificationsData.setTotalNotificationsUnread(context.totalUnread);

        if (context.notifications.length > 0) {
            this._updateNotificationListHtml()
        } else {
            $sectionContent.addClass("empty-data-info");
            $sectionContent.html("<div class='text'>" + Translator.trans("TR_NO_HAY_NOTIFICACIONES").replace("\n", "<br>") + "</div>");

        }
        const $notificationsList = $("section.data-list-section[data-list=notifications] div.section-content");
        $notificationsList.on("click.openNotification", "div.activity-card.is-notification-card", this._onclickNotification.bind(this));
        
        $notificationsList.on("click.markNotificationAsRead", "div.activity-card.is-notification-card .mark-as-seen-button", this._markNotificationAsRead.bind(this));
    }

    _manageNotificationsListScroll() {

        function _onGetMoreNotificationsSuccess(response) {

            pendingRequest = false;
            requestFrom += response.result.notifications.length
           
            _.forEach(response.result.notifications, function(notification) {

                if (notification.value.alert_original) {
                    notification.value.alertFormatted = DocumentationUtils.formatNotificationCommentMentions(notification.value.alert_original, notification.value.mentions, null);
                }

                if (notification.value.internal_link) {
                    notification.value.internal_link.documentData = documentationScreenController.getDocument(notification.value.internal_link.resource);
                    notification.value.internal_link.documentData.progressState = documentationScreenController.documentationProgress.getProgressState(notification.value.internal_link.documentData);
                    DocumentationUtils.formatDocumentParameters(notification.value.internal_link.documentData);
                }

            });

            that._listNotificationsData.setNotificationsList(response.result.notifications);
            that._updateNotificationListHtml()
        }

        function _getMoreNotifications() {

            const scrollHeight = $document.height();
            const windowHeight = $window.height();
            const currentScrollPosition = $window.scrollTop();
            const distanceToBottom = 100;

            if (currentScrollPosition > lastScrollPosition && currentScrollPosition + windowHeight >= scrollHeight - distanceToBottom) {

                if (!pendingRequest) {

                    pendingRequest = true;

                    api.getNotifications(requestFrom, null, null, _onGetMoreNotificationsSuccess, false);

                }

            }

            lastScrollPosition = currentScrollPosition;

        }

        function _setNotificationRead() {

            const currentScrollPosition = parseInt($window.scrollTop());

            // Si la notificacion esta en medio de la pantalla se marca como leida se elimina de la lista y se obtiene el proximo
            if (currentScrollPosition + ($window.height() / 2) > nextNotificationOffset) {

                const $notificationCard = $(".activity-card.is-notification-card[data-offset=" + nextNotificationOffset + "]");

                $notificationCard.trigger("click");
                _.remove(managerNotificationsOffsets, function(item) { return item === nextNotificationOffset; });
                nextNotificationOffset = _.min(managerNotificationsOffsets);

            }


        }

        const that = this;
        const $window = $(window);
        const $document = $(document);
        const $dataListSection = $("section.data-list-section div.section-content");
        const limit = 20;
        let requestFrom = this._listNotificationsData.getNotificationsList().length;
        let lastScrollPosition = 0;
        let pendingRequest = false;

        // Almacena las posiciones de las notificaciones
        const managerNotificationsOffsets = [];

        // Selectores de las notificaciones del manager que son las que se quieren marcar como leidas por scroll
        const $managerNotifications = $(".activity-card.is-notification-card[data-type=GENERIC], .activity-card.is-notification-card[data-type=GENERIC_BROADCAST], .activity-card.is-notification-card[data-type=IMAGE]");
        let nextNotificationOffset = null;

        // Se establece con un data la posicion del elemento en el scroll (para poder seleccionarlo luego por este valor)
        $managerNotifications.each(function() {

            const $this = $(this);
            const offsetTop = parseInt($this.offset().top)

            $this.attr("data-offset", offsetTop);
            managerNotificationsOffsets.push(offsetTop);

        })

        // Se obtiene la proxima posicion de la notificacion que se debe marcar como leida al hacer scroll
        nextNotificationOffset = _.min(managerNotificationsOffsets);

        $window.on("scroll.notificationsList", function() {
            _getMoreNotifications();
            _setNotificationRead();
        });

    }

    _updateNotificationsList(notificationId) {

        function _onNotificationReadedSuccess() {

            $notificationCard.data("read", true);
            $notificationCardBadge.hide();
            that._listNotificationsData.markNotificationAsRead(notificationId);

            const totalNotificationsUnreaded = that._listNotificationsData.getTotalNotificationsUnread() - 1;
            that._listNotificationsData.setTotalNotificationsUnread(totalNotificationsUnreaded);

            $headerSubtitle.text(sprintf(Translator.trans("TR_X_NUEVAS"), totalNotificationsUnreaded));

            if (totalNotificationsUnreaded === 0) {

                const hasNotificationIcon = $("#open-notifications-button > div.has-notifications");
                const hasNotNotificationsIcon = $("#open-notifications-button > div.has-not-notifications");

                hasNotificationIcon.hide();
                hasNotNotificationsIcon.show();

            }
            that._updateNotificationListHtml()
        }

        const $notificationCard = $("div.activity-card.is-notification-card[data-notification=" + notificationId + "]");
        const $notificationCardBadge = $notificationCard.find("div.new-notification-indicator");
        const $headerSubtitle = $("section.data-list-section div.section-header p.subtitle");
        const notificationReaded = $notificationCard.data("read");
        const that = this;

        if (!notificationReaded) {
            api.setNotificationReaded(notificationId, _onNotificationReadedSuccess, false);
        }

    }

    _onclickUser(event) {
        event.preventDefault();
        event.stopPropagation();

        const $this = $(event.currentTarget);
        const userWorldId = $this.data("user");

        api.getUserProfile(world.token, userWorldId, false);

    }

    _markNotificationAsRead(event) {
        event.preventDefault();
        event.stopPropagation();
        const $this = $(event.currentTarget);
        const notificationId = $this.data("notification");
        this._updateNotificationsList(notificationId);
    }

    _onclickNotification(event) {
        event.preventDefault();
        event.stopPropagation();

        const $this = $(event.currentTarget);
        const notificationType = $this.data("type");
        const notificationId = $this.data("notification");
        const notificationTypes = this._notificationTypes.getNotificationTypes();
        let documentId = null;
        let commentId = null;
        let roomId = null;
        let userWorldId = null;

        switch (notificationType) {

            case notificationTypes.PUBLICATION_COMMENT_NEW:
            case notificationTypes.COMMENT_LIKED:
            case notificationTypes.COMMENT_MENTION:
            case notificationTypes.FOLLOWING_COMMENT_LIKED:
            case notificationTypes.FOLLOWING_PUBLICATION_COMMENT_NEW:
                documentId = $this.data("document");
                commentId = $this.data("comment");
                this._openPublicationCommentTab(documentId, commentId);
                break;

            case notificationTypes.PUBLICATION_FAVOURITE:
            case notificationTypes.PUBLICATION_LIKED:
            case notificationTypes.PUBLICATION_COMPLETED:
            case notificationTypes.PUBLICATION_VIEWED:
            case notificationTypes.FOLLOWING_PUBLICATION_NEW:
            case notificationTypes.FOLLOWING_PUBLICATION_LIKED:
            case notificationTypes.FOLLOWING_PUBLICATION_FAVOURITE:
            case notificationTypes.INTERNAL_LINK:
                documentId = $this.data("document");
                this._openPublication(documentId);
                break;

            case notificationTypes.NEW_CHALLENGE:
            case notificationTypes.CHALLENGE_FINISHED:
                this._openChallengeTab();
                break;

            case notificationTypes.CHAT_NEW_MESSAGE:
                roomId = $this.data("room");
                this._openChatRoom(roomId);
                break;

            case notificationTypes.FOLLOWER_NEW:
                userWorldId = $this.data("user");
                this._openUserProfile(userWorldId);
                break;

            case notificationTypes.TASK:
                this._openTaskNotification($this);
                break;

        }

        this._updateNotificationsList(notificationId);

    }

    _closeDrawerIfOpen() {
        if (this.openInDrawer) {
            document.dispatchEvent(new CustomEvent('closeNotificationDrawer'));
        }
    }

    _openPublicationCommentTab(documentId, commentId) {

        const doc = documentationScreenController.getDocument(documentId);
        const folder = doc.folder;

        if (!doc) {

            swal({
                title: "",
                text: Translator ? Translator.trans('TR_ERROR_OBTENIENDO_INFORMACION') : '',
                type: 'warning',
                confirmButtonText: ''
            });

        } else {

            this._closeDrawerIfOpen();
            documentationScreenController.documentationScroll.lastScrollPosition = $(window).scrollTop();
            documentationScreenController.documentationSockets.startNodeConnection();

            documentationScreenController.drawDocumentDetails(null, doc, null, folder);

            const $detailsToggleButton = $("#document-details-toggle-button");
            const $commentsTab = $("#comments-tab");

            $detailsToggleButton.trigger("click");
            $commentsTab.trigger("click");

            // Esperar a que el listado de comentarios esté cargado
            $(document).off("ajaxStop.loadComments").one("ajaxStop.loadComments", function() {

                const $commentsList = $("#comments");
                const $documentComment = $(".document-comment[data-comment=" + commentId + "]");

                // Hacer scroll hasta la posición del comentario que ha producido la notificacion
                // Se resta la position de la lista porque el offset() es relativo al documento no a un elemento padre contenedor
                $commentsList.scrollTop($documentComment.offset().top - $commentsList.offset().top);

            });

        }

    }

    _openPublication(documentId) {

        const doc = documentationScreenController.getDocument(documentId);
        const folder = doc.folder;

        if (!doc) {

            swal({
                title: "",
                text: Translator ? Translator.trans('TR_ERROR_OBTENIENDO_INFORMACION') : '',
                type: 'warning',
                confirmButtonText: ''
            });

        } else {

            this._closeDrawerIfOpen();
            documentationScreenController.documentationScroll.lastScrollPosition = $(window).scrollTop();
            documentationScreenController.documentationSockets.startNodeConnection();
            documentationScreenController.drawDocumentDetails(null, doc, null, folder);

        }

    }

    _openChallengeTab() {

        if (window.reactZustandBridge && world?.mode === 'newLayout') {
            this._closeDrawerIfOpen();
            window.reactZustandBridge.navigate('/challenges');
            return;
        }

        function _onGetPendingChallengesSuccess(response) {

            const tabs = new Tabs();
            const tabData = baseController.getTabById(tabs.RETOS_TAB);
            const template = Handlebars.compile($("#worldChallengeScreen").html());
            const context = {
                challenges: response.result, user: user,
                starIcon: customIcons["BET_ICON"]
            };
            let pendingChallengesCount = 0;

            documentationScreenController.documentationScroll.lastScrollPosition = $(window).scrollTop();
            challengeListScreenController.pendingChallenges = response.result;

            baseController.stackFullScreenMenu(tabData.name);
            baseController.stackSimpleContent(template, context);

            api.getHistoryChallenges(world.token);
            api.tintStars();

            $.each(response.result.challenges, function (index, challenge) {
                if (challenge.game.user_world_creator_id != user.user_world_id) {
                    pendingChallengesCount++;
                }
            });

            if (pendingChallengesCount > 0) {
                const $challengesText = $('#baseBadgeChallengesTxt');
                $challengesText.text(pendingChallengesCount);
            }

            const $notificationsButton = $("#open-notifications-button");
            const $challengeTabCloseButton = $("#documentation-header-close-btn");

            $notificationsButton.hide();
            $challengeTabCloseButton.one("click.closeChallengeTab", function() {
                $notificationsButton.show();
            });

        }

        api.getPendingChallenges(world.token, true, false, _onGetPendingChallengesSuccess);

    }

    _openChatRoom(roomId) {

        function _onRoomHasBeenDrawn() {

            const $notificationsButton = $("#open-notifications-button");
            const $chatTabCloseButton = $("#documentation-header-close-btn");
            const $chatRoomBackbutton = $("div.top-chat-info-back-btn");
            const $document = $(document).off('click.exitChatRoom');

            // Deshabilitar el back button de la sala de chat ya que su comportamiento no es el mismo que cuando se abre desde las notificaciones
            $document.off('click.exitChatRoom');

            $notificationsButton.hide();

            $chatTabCloseButton.one("click.closeChatTab", function(event) {
                $notificationsButton.show();
            });

            $chatRoomBackbutton.one("click.closeChatTab", function(event) {
                $chatTabCloseButton.trigger("click");
            });

        }

        function _filterRoomCondition(room) {
            return room.id === roomId;
        }

        const roomToDraw = chatScreenController.allRooms.rooms.filter(_filterRoomCondition)[0];
        const tabs = new Tabs();
        const tabData = baseController.getTabById(tabs.CHAT_TAB);

        documentationScreenController.documentationScroll.lastScrollPosition = $(window).scrollTop();
        baseController.stackFullScreenMenu(tabData.name);
        chatScreenController.drawIndividualChat(roomToDraw, _onRoomHasBeenDrawn);

    }

    _openUserProfile(userWorldId) {
        api.getUserProfile(world.token, userWorldId, false);
    }

    _openTaskNotification($card) {
        if (!window.reactZustandBridge || !window.reactZustandBridge.getV2ExternalLoginTabLink) return;

        const campaignId = $card.data('campaign');
        const taskId = $card.data('task');
        const postMessage = (typeof keycloakAuth !== 'undefined' && keycloakAuth.accessToken)
            ? { token: keycloakAuth.accessToken, refreshToken: keycloakAuth.refreshToken, clientId: keycloakAuth.clientId }
            : undefined;

        const { URI } = window.reactZustandBridge.getV2ExternalLoginTabLink({
            redirectTo: 'task',
            worldId: String(world.id),
            extraParams: { campaignId, taskId },
            postMessage
        });

        window.reactZustandBridge.handleNewTabClick(URI, postMessage);
    }

    _onSearchSubmit(event) {

        function _onGetNotificationsSuccess(response) {

            if (api.checkisValidResult(response)) {

                _.forEach(response.result.notifications, function(notification) {

                    if (notification.value.alert_original) {
                        notification.value.alertFormatted = DocumentationUtils.formatNotificationCommentMentions(notification.value.alert_original, notification.value.mentions, null);
                    }

                    if (notification.value.internal_link) {
                        notification.value.internal_link.documentData = documentationScreenController.getDocument(notification.value.internal_link.resource);
                        notification.value.internal_link.documentData.progressState = documentationScreenController.documentationProgress.getProgressState(notification.value.internal_link.documentData);
                        DocumentationUtils.formatDocumentParameters(notification.value.internal_link.documentData);
                    }

                });

                if (searchTerm.length > 0) {
                    $clearSearchButton.show();
                } else {
                    $clearSearchButton.hide();
                }

                that._listNotificationsData.setNotificationsList(response.result.notifications);
                that._updateNotificationListHtml()
            }

        }

        const $this = $(event.currentTarget);
        const $dataListSection = $("section.data-list-section");
        const $searchInput = $this.find(".search-input");
        const $clearSearchButton = $("div.clear-search-button");
        const searchTerm = $searchInput.val().trim();
        const that = this;

        event.preventDefault();

        api.getNotifications(null, null, searchTerm, _onGetNotificationsSuccess, false);

    }

    markAllNotificationsAsRead() {
        const that = this;

        function _onSetAllNotificationsReadedSuccess() {
            that._listNotificationsData._notificationsList.forEach(notification => {
                that._listNotificationsData.markNotificationAsRead(notification.id);
                const $notificationCard = $("div.activity-card.is-notification-card[data-notification=" + notification.id + "]");
                $notificationCard.data("read", true);
                $notificationCard.find("div.new-notification-indicator").hide();
            })
            const $headerSubtitle = $("section.data-list-section div.section-header p.subtitle");
            $headerSubtitle.text(sprintf(Translator.trans("TR_X_NUEVAS"), 0));
        }

        api.setAllNotificationsReaded(_onSetAllNotificationsReadedSuccess);
    }

    initialize(data, openInDrawer = false) {
        this.openInDrawer = openInDrawer ?? false;

        this._drawScreen(data);
        this._enableHandlers();
        this._manageNotificationsListScroll();
        this._dataListUtils.changeHeaderMode(this._dataListData);
    }

}